import React, { useEffect, useState } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import AgGridRowCheckbox from '@/components/common/TableGrid/CustomComponents/AgGridCheckbox/BaseRowCheckbox';

interface AgGridHeaderCheckboxProps extends ICellRendererParams { }

export default function RowCheckbox(params: AgGridHeaderCheckboxProps) {
  const { node, api } = params;
  const [isSelected, setSelected] = useState(node.isSelected() ?? false);

  const onChange = () => {
    setSelected(!isSelected);
  };

  const selectionChanged = () => {
    const isRowSelected = node.isSelected();
    if (typeof isRowSelected === 'undefined') return;
    setSelected(isRowSelected);
  };

  useEffect(() => {
    api.addEventListener('selectionChanged', selectionChanged);

    return () => {
      api.removeEventListener('selectionChanged', selectionChanged);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    node.setSelected(isSelected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelected]);

  return (
    <AgGridRowCheckbox
      {...params}
      id={`custom-grid-row-${node.id}`}
      checked={isSelected}
      onChange={onChange}
    />
  );
}
